<template>
  <div class="auth-organization-picker">
    <form-group label="Farmacias registradas" for-id="medication-route-code">
      <el-select
        id="organization-picker"
        v-model="organization"
        filterable
        placeholder="Organización"
        @input="handleSelectOrganization">
        <el-option
          v-for="organization in organizations"
          :key="organization.uuid"
          :label="organizationLabel(organization)"
          :value="organization.uuid" />
      </el-select>
    </form-group>
  </div>
</template>

<script>
import FormGroup from '@/components/FormGroup';
export default {
  name: 'AuthOrganizationPicker',
  components: { FormGroup },
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      organization: null
    };
  },
  computed: {
    organizations() {
      return this.user.organizations;
    }
  },
  methods: {
    handleSelectOrganization(organizationUuid) {
      this.$emit('select-organization', organizationUuid);
    },
    organizationLabel(organization) {
      return `${organization.code} - ${organization.name} - ${organization.address}`;
    }
  }
};
</script>
